import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxEchartsModule } from 'ngx-echarts';
import { LoyaltyDashboardRoutingModule } from './loyalty-dashboard-routing.module';
import { LoyaltyDashboardComponent } from './loyalty-dashboard.component';
import { LoyaltyDashboardApiService } from './services/loyalty-dashboard-api.service';
import { echarts } from './echarts-setup';

@NgModule({
  imports: [
    CommonModule,
    LoyaltyDashboardRoutingModule,
    LoyaltyDashboardComponent,
    NgxEchartsModule.forRoot({ echarts }),
  ],
  providers: [LoyaltyDashboardApiService],
})
export class LoyaltyDashboardModule {}
